import React from 'react'

import { ZariContext } from '_zari/context'
import { Col, Row, Portlet, Button } from '_zari/core'

import { MesesContabilidadConstant } from 'constants/index'

import { DownloadAxiosFile } from 'utils'

import * as PresupuestoNuevoServices from 'services/presupuestoNuevo.service'

import * as FormGroups from './formGroups'

const Comparativo = () => {
  const __zariContext = React.useContext(ZariContext)

  const [mesSeleccionado, setMesSeleccionado] = React.useState(MesesContabilidadConstant.ENERO)
  const [companiaSeleccionada, setCompaniaSeleccionada] = React.useState(null)

  const clickDescargarReporte = React.useCallback(() => {
    if (companiaSeleccionada) {
      __zariContext.loader.open('Descargando reporte comparativo')
      PresupuestoNuevoServices.descargarReporteComparativo({
        mes: mesSeleccionado,
        idCompaniaComparar: companiaSeleccionada
      })
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
        .finally(() => {
          __zariContext.loader.close()
        })
    } else {
      __zariContext.snack('error', 'El campo Compañia es requerido')
    }
  }, [companiaSeleccionada, mesSeleccionado, __zariContext])

  return (
    <Portlet className='zari-slim-form'>
      <Portlet.Header title='Reporte Comparativo' />
      <Portlet.Body>
        <Row>
          <Col md={10}>
            <FormGroups.MesFormGroup mesSeleccionado={mesSeleccionado} setMesSeleccionado={setMesSeleccionado} />
          </Col>
        </Row>
        <Row>
          <Col md={10}>
            <FormGroups.CompaniaFormGroup
              companiaSeleccionada={companiaSeleccionada}
              setCompaniaSeleccionada={setCompaniaSeleccionada}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickDescargarReporte}>Descargar Reporte</Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(Comparativo)
